import { create as createZustandStore } from 'zustand';
import type { StateCreator } from 'zustand';

const storeResetters = new Map<object, () => void>();

const create = (<T>(stateCreator?: StateCreator<T>) => {
  if (stateCreator === undefined) {
    return create;
  }

  const store = createZustandStore(stateCreator);
  const initialState = store.getState();
  storeResetters.set(store, () => store.setState(initialState, true));

  return store;
}) as typeof createZustandStore;

export const resetZustandStores = () => {
  storeResetters.forEach(resetStore => resetStore());
};

export const registerZustandStoreReset = (store: object, resetStore: () => void) => {
  storeResetters.set(store, resetStore);
};

export { create };
